import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

interface IResponse {
    phone?: string;
    verified: boolean;
}

export async function sendPhoneVerificationCode(phone: string) {
    try {
        const { data } = await axios.post<IResponse>(Endpoints.User.Phone, { phone });

        return data.verified;
    } catch (error) {
        return false;
    }
}
